__turbopack_context__.v({
  "item": "NavigationDesktop-module-scss-module__14jtiG__item",
  "navigation": "NavigationDesktop-module-scss-module__14jtiG__navigation",
});
